import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { selectQuotationForm } from "app/containers/WorkOrder/redux/selector";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { formKey } from "../../../hooks/useQuoteBoxStructure";
import { useStyles } from "../styles";

const closedKey = (suffix: string) => formKey(`CLOSED_BOX.${suffix}`);

const ReadOnlyField = ({
  labelKey,
  value,
  currency,
}: {
  labelKey: string;
  value: string;
  currency?: boolean;
}) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <Box className={styles.fieldMetric}>
      <Typography className={styles.fieldMetricLabel}>{t(labelKey)}</Typography>
      <Typography className={styles.fieldMetricValue}>
        {currency ? (
          <span dir="ltr">{t("QUOTES.CURRENCY", { amount: value })}</span>
        ) : (
          value
        )}
      </Typography>
    </Box>
  );
};

const QuoteCosts = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const form = useSelector(selectQuotationForm);

  return (
    <Box className={styles.sectionsCard}>
      <Box className={styles.formSection}>
        <Box className={styles.sectionHeaderPlain}>
          <Typography className={styles.sectionTitle}>
            {t(formKey("SECTIONS.BASE_COSTS"))}
          </Typography>
        </Box>
        <Box className={styles.grid4}>
          <ReadOnlyField
            labelKey={closedKey("FIELDS.WORK_HOURS_STANDARD")}
            value={form.workHours}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.PER_HOUR")}
            value={form.perHour}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.REPAIR_HOURS")}
            value={form.repairHours}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.TOTAL_WORK_COST")}
            value={form.totalWorkCost}
            currency
          />
        </Box>
      </Box>

      <Box className={styles.formSection}>
        <Box className={styles.sectionHeader}>
          <Typography className={styles.sectionTitle}>
            {t(formKey("SECTIONS.PARAMETERS_COEFFICIENTS"))}
          </Typography>
        </Box>
        <Box className={styles.grid4}>
          <ReadOnlyField
            labelKey={closedKey("FIELDS.SHEET_METAL_COST")}
            value={form.sheetMetalCost}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.EXCHANGE_RATE")}
            value={form.dollarRate}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.ESTIMATED_WEIGHT")}
            value={form.estimatedWeight}
          />
          <ReadOnlyField
            labelKey={formKey("FIELDS.COEFFICIENTS")}
            value={form.coefficients}
          />
        </Box>
      </Box>

      <Box className={styles.formSection}>
        <Box className={styles.sectionHeader}>
          <Typography className={styles.sectionTitle}>
            {t(closedKey("SECTIONS.LEASING"))}
          </Typography>
        </Box>
        <Box className={styles.grid4}>
          <ReadOnlyField
            labelKey={closedKey("FIELDS.LEASING_INSTALLATION")}
            value={form.leasingInstallation}
            currency
          />
        </Box>
      </Box>
    </Box>
  );
};

export default QuoteCosts;
